import styled from 'styled-components';
import Flex from '../Flex';
import Text from '../Text';

export const Container = styled(Flex)`
  flex-direction: column;
  background: ${({ theme }) => theme.colors.semantic.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  padding: 16px 16px 16px 0;
  gap: 8px;
  align-self: flex-start;
  min-width: 240px;
`;

export const ListGroup = styled(Flex)`
  flex-direction: column;
  gap: 8px;
`;

export const ListGroupItem = styled(Flex)`
  padding-left: ${({ active }) => (active ? '21px' : '24px')};
  padding-top: 4px;
  padding-bottom: 4px;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  color: ${({ active, theme }) =>
    active ? theme.colors.primary500 : theme.colors.semantic.text.secondary};

  border-left: ${({ active, theme }) =>
    active ? `3px solid ${theme.colors.primary500}` : 'none'};
`;

export const SubListGroupItem = styled(Flex)`
  padding-left: ${({ active }) => (active ? '37px' : '40px')};
  padding-top: 4px;
  padding-bottom: 4px;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;

  color: ${({ active, theme }) =>
    active ? theme.colors.primary500 : theme.colors.semantic.text.secondary};

  border-left: ${({ active, theme }) =>
    active ? `3px solid ${theme.colors.primary500}` : 'none'};
`;

export const Title = styled(Text)`
  font-family: 'Lato', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  padding-left: 16px;
  width: 100%;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;
